import { render, staticRenderFns } from "./complaint-form.component.vue?vue&type=template&id=fcb995e2&"
import script from "./complaint-form.component.ts?vue&type=script&lang=ts&"
export * from "./complaint-form.component.ts?vue&type=script&lang=ts&"
import style0 from "./complaint-form.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports